module.exports = __webpack_public_path__ + "static/media/stat1.3f125a64.png";